<script lang="ts">
import { SiteBanner } from '@viamrobotics/prime-core';

import { browser } from '$app/environment';
import {
  dismissAnnouncement,
  parseAnnouncement,
  shouldShowAnnouncement,
} from '$lib/announcement-banner';

interface Props {
  /** Raw ANNOUNCEMENT_BANNER feature flag value. */
  value: string | undefined;
}
const { value }: Props = $props();

const announcement = $derived(value ? parseAnnouncement(value) : null);

// Writable $derived: recomputes from storage when the campaign changes, and the
// dismiss handler can override it to false until the next campaign arrives.
let visible = $derived(
  announcement ? shouldShowAnnouncement(announcement) : false
);

const handleDismiss = () => {
  dismissAnnouncement();
  visible = false;
};
</script>

{#if browser && announcement && visible}
  <SiteBanner
    variant="announcement"
    badge={announcement.badge}
    segments={announcement.segments}
    onDismiss={handleDismiss}
  />
{/if}
